// Hinglish (Roman-script) dictionary for vee-validate.
// Wired up in src/main.js via Validator.localize('hinglish', veeHinglish).

export default {
  messages: {
    required:  (field)      => `${field} field zaroori hai`,
    email:     (field)      => `${field} ek valid email hona chahiye`,
    max:       (field, [n]) => `${field} ${n} characters se zyada nahi ho sakta`,
    min:       (field, [n]) => `${field} kam se kam ${n} characters ka hona chahiye`,
    max_value: (field, [n]) => `${field} ${n} se zyada nahi ho sakta`,
    min_value: (field, [n]) => `${field} ${n} se kam nahi ho sakta`,
    numeric:   (field)      => `${field} mein sirf digits hone chahiye`,
    decimal:   (field, [d]) => `${field} ek valid number hona chahiye (max ${d || ''} decimals)`.trim(),

    nospace:           () => `Space characters allowed nahi hain`,
    verify_pincode:    () => `Pincode valid nahi hai`,
    verify_gstnumber:  () => `GST Number valid nahi hai`,
    verify_pannumber:  () => `PAN Number valid nahi hai`,
    verify_hsn:        () => `HSN code 4, 6 ya 8 digits ka hona chahiye`,
  },

  attributes: {
    'name':                 'Name',
    'display name':         'Display Name',
    'business name':        'Business Name',
    'business owner name':  'Business Owner Name',
    'mobile number':        'Mobile Number',
    'phone number':         'Phone Number',
    'email':                'Email',
    'address':              'Address',
    'state':                'State',
    'otp':                  'OTP',

    'GST number':                 'GST Number',
    'gst number':                 'GST Number',
    'GST registration status':    'GST Registration Status',
    'GST 2.0 Percentage':         'GST 2.0 Percentage',
    'gst rate':                   'GST Rate',
    'tax (percentage)':           'Tax (Percentage)',
    'cess (percentage)':          'Cess (Percentage)',
    'cess precentage':            'Cess Percentage',
    'cess 2.0 percentage':        'Cess 2.0 Percentage',
    'cess amount':                'Cess Amount',
    'cess value':                 'Cess Value',
    'hsn code':                   'HSN Code',
    'export type':                'Export Type',

    'account ledger':             'Account Ledger',
    'expense category':           'Expense Category',
    'expense ledger':             'Expense Ledger',
    'on account':                 'On Account',
    'new balance':                'New Balance',

    'transaction type':           'Transaction Type',
    'bill number':                'Bill Number',
    'next number':                'Next Number',
    'prefix':                     'Prefix',
    'amount':                     'Amount',
    'round off':                  'Round Off',
    'due days':                   'Due Days',
    'payment term':               'Payment Term',
    'return qty':                 'Return Quantity',

    'Batch Number':               'Batch Number',
    'Low Stock Qty':              'Low Stock Quantity',
    'quantity':                   'Quantity',
    'pack qty':                   'Pack Quantity',
    'secondary pack qty':         'Secondary Pack Quantity',
    'primary unit':               'Primary Unit',
    'unit quantity code':         'Unit Quantity Code',
    'conversion rate':            'Conversion Rate',
    'from godown':                'From Godown',
    'to godown':                  'To Godown',
    'purchase rate':              'Purchase Rate',
    'whole sale price':           'Wholesale Price',

    'UPI ID':                     'UPI ID',
    'UPI Name':                   'UPI Name',

    'billing label':              'Billing Label',
    'shipping label':             'Shipping Label',
  },
}



// WEBPACK FOOTER //
// ./src/locales/vee_hinglish.js